import React from 'react'
import ChevronGreen from 'assets/icon/chevron-green.png'
import ChevronGrey from 'assets/icon/chevron-grey.png'
import KomentExpert from 'assets/icon/koment-expert.png'
import CommentBlue from 'assets/icon/comment-blue.png'
import CommentGrey from 'assets/icon/comment-grey.png'
import IsMark from 'assets/icon/is-mark.png'
import IsFlag from 'assets/icon/is-flag.png'
import EyeGrey from 'assets/icon/eye-grey.png'
import FlagGrey from 'assets/icon/flag-grey.png'
import FlagRed from 'assets/icon/flag-red.png'
import DefaultAva from 'assets/icon/default-ava.jpeg'
import SmartText from '../SmartText';
import FileGambar from '../home/FileGambar';
import FileLink from '../home/FileLink';
import FilePdf from '../home/FilePdf';
import FileVideo from '../home/FileVideo';

import LikeGreen from 'assets/icon/like-green.png'
import LikeGrey from 'assets/icon/like-grey.png'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Kebab from 'assets/icon/Kebab.png'
import { Button } from '@material-ui/core';
import Cookie from 'universal-cookie'

const cookie=new Cookie()
const profile=cookie.get('profile_cookie_forum')

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      padding:8,
      backgroundColor: 'black',
      color: 'white',
      fontSize: theme.typography.pxToRem(12),
      border: 'black',
      boxShadow: 'black',
    },
    arrow: {
        "&:before": {
          border: '1px solid black',
          backgroundColor: "black",
        },
      },
  }))(Tooltip);
export default function CardComment(props) {
    let {
        data,
        onClickVote,
        index,
        onClickFlag,
        replyComment,
        onClickMark,
        forum_auth,
        option_comment,
        optionCommentToggle,
        editComment,
        deleteComment
    }=props
    function get_url_extension( url ) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    function linkify(text) {
        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return text.match(urlRegex)
    }
    let extension=get_url_extension(data.attachment)
    const renderPreviewFile=()=>{
        if(extension==='jpg'||extension==='jpeg'||extension==='png'){
            return <div className="card-file"><br/><FileGambar url={data.attachment}/><br/></div>
        }
        if(extension==='pdf'){
            return <div className="card-file"><br/><FilePdf url={data.attachment}/><br/></div>
        }
        if(extension==='mp4'){
            return <div className="card-file"><br/><FileVideo url={data.attachment}/><br/></div>
        }
        if(linkify(data.text)!==null){
            return <div className='card-file'><br/><FileLink url={linkify(data.text)[0]} /><br/></div>
        }
    }
    const renderVoteImg=(data)=>{

        if(data.nvote>0){
            return LikeGreen

        }else{
            return LikeGrey

        }
    }
    const renderCommentImg=(data)=>{
        if(data.isExpert){
            if(data.nMark>0){
                return KomentExpert
            }else{
                return CommentBlue
            }
        }else{
            return CommentGrey
        }
        
    }
    const renderEyeImg=(data)=>{
        return EyeGrey
    }
    const renderFlagImg=(data)=>{
        if(data.nflag>0){
            return FlagRed
        }else{
            return FlagGrey
        }
    }
    const handleDisabled=()=>{
        if(data.author.userId===profile.id){
            if(data.ncomment>0){
                return false
            }else{
                return true
            }
        }else{
            return false
        }
    }
    function renderOptionCard(){
        return(
            <div>
                {handleDisabled()&&
                    <>
                        <Button onClick={()=>editComment(data,index)} className='btn-remove-capital' variant="text" color="primary" size="small">Ubah</Button>
                        <div style={{width:'100%',height:0.5,backgroundColor:'#aaaaaa'}}></div>
                    </>
                }
                {(handleDisabled()||forum_auth.isAdministrator)&&
                    <>
                        <Button onClick={()=>deleteComment(data,index)}  className='btn-remove-capital' variant="text" color="secondary" size="small">Hapus</Button>
                        <div style={{width:'100%',height:0.5,backgroundColor:'#aaaaaa'}}></div>
                    </>
                }
                
            </div>

        )
    }
    const handleDisabledComment=(data)=>{
        // return true
        if(data.author.userId===profile.id){
            if(data.child.length===0){
                return true
            }else{
                return false
            }
        }else{
            return false
        }
    }
    function urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
          return '<a href="' + url + '">' + url + '</a>';
        })
    }
    return (
        <div>
            <div className='comment-wrapper'>
                {option_comment[index]&&<div onClick={()=>optionCommentToggle(data,index)} className='option-backdoor'></div>}

                <div className='comment-item'>
                    <div className='div-flex' style={{width:'100%'}}>
                        <div className='comment-ava'>
                            <img src={data.author.profilePic!==''?data.author.profilePic:DefaultAva} className='comment-ava-img'/>
                            {data.nMark>0&&<div className='icon-status-wrapper'><img src={IsMark} className='icon-status'/><p className='font-nunito margin-0'>{data.nMark}</p></div>}
                            {data.nflag>0&&<div className='icon-status-wrapper'><img src={IsFlag} className='icon-status'/><p className='font-nunito margin-0'>{data.nflag}</p></div>}
                        </div>

                        <div className='comment-content'>
                            <div className='div-flex div-justify-between comment-head'>
                                <p className='font-nunito margin-0'>Dibuat oleh <span className='font-bold'>{data.author.name}</span></p>
                                <p className='font-nunito margin-0' style={{color:'#777777'}}>{data.lastActivity}</p>
                            </div>
                            <div className='comment-desc'>
                                <SmartText text={urlify(data.text)}/>
                                {/* <p className='font-nunito margin-0'>Paragrah singkat mengenai open diskusinya Paragrah singkat mengenai open diskusinya Paragrah singkat mengenai open diskusinya Paragrah singkat mengenai open diskusinya Paragrah singkat  …</p> */}
                            </div>
                            
                        </div>
                    </div>
                    {renderPreviewFile()}
                    <div className='div-flex div-justify-between div-align-center comment-footer'>
                        <div className='div-flex div-align-center comment-action'>
                            {forum_auth.canComment&&<p onClick={()=>replyComment(data)} className='font-nunito margin-0 font-bold'>Balas</p>}
                            {data.canMark&&data.isMark===false&&
                                <>
                                    <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                    <p onClick={()=>onClickMark(data,index)} className='font-nunito margin-0 font-bold'>Tandai Sebagai Solusi</p>
                                </>
                            }
                            
                        </div>
                        <div className='div-flex div-align-center comment-icon'>
                            {forum_auth.canVote&&
                                <HtmlTooltip title="Suka" placement="bottom" arrow>
                                <div className='footer-action'>
                                    <img onClick={()=>onClickVote(data,index)} src={renderVoteImg(data)} />
                                    <p className='font-nunito margin-0 '>{data.nvote!==0&&data.nvote}</p>
                                </div>
                                </HtmlTooltip>
                            
                            }
                            <HtmlTooltip title={`${data.ncomment===0?'Belum ada tanggapan':data.nMark===0?`${data.ncomment} komentar`:`${data.ncomment} Komentar dengan ${data.nMark} Komentar solutif`}`} placement="bottom" arrow>
                                <div className='footer-action'>
                                    <img src={renderCommentImg(data)} />
                                    <p className='font-nunito margin-0 '>{data.ncomment!==0&&data.ncomment}</p>
                                </div>
                            </HtmlTooltip>
                            
                            {forum_auth.canFlag&&
                                <HtmlTooltip title="Laporkan diskusi ini" placement="bottom" arrow>

                                    <div className='footer-action'>
                                        <img onClick={()=>onClickFlag(data,index)} src={renderFlagImg(data)}/>
                                    </div>
                                </HtmlTooltip>
                            
                            }
                            <div className='footer-action card-option'>
                                <img onClick={()=>optionCommentToggle(data,index)} src={Kebab}/>
                                {option_comment[index]&&<div className='option-container'>
                                    {/* <Button  onClick={()=>editComment(data,index)} className='btn-remove-capital' variant="text" color="primary" size="small">Ubah</Button>
                                    <div style={{width:'100%',height:0.5,backgroundColor:'#aaaaaa'}}></div>
                                    <Button  onClick={()=>deleteComment(data,index)}  className='btn-remove-capital' variant="text" color="secondary" size="small">Hapus</Button> */}
                                    {renderOptionCard()}

                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                {data.child.map((s,i2)=>(
                    <div key={i2}>
                        <div className='sub-comment margin-left20 div-flex'>
                            <div className='comment-ava'>
                                <img src={s.author.profilePic!==''?s.author.profilePic:DefaultAva} className='comment-ava-img'/>
                                {s.nMark>0&&<div className='icon-status-wrapper'><img src={IsMark} className='icon-status'/><p className='font-nunito margin-0'>{s.nMark}</p></div>}
                                {s.nflag>0&&<div className='icon-status-wrapper'><img src={IsFlag} className='icon-status'/><p className='font-nunito margin-0'>{s.nflag}</p></div>}
                            </div>
                            <div style={{width:'100%'}}>
                                <div className='sub-comment-content'>
                                    <div className='div-flex div-justify-between sub-coment-head'>
                                        <p className='font-nunito margin-0'><span className='font-bold'>{s.author.name}</span></p>
                                        <p className='font-nunito margin-0' style={{color:'#777777'}}>{s.lastActivity}</p>
                                    </div>
                                    <div className='sub-comment-desc'>
                                        <SmartText text={s.text}/>
                                    </div>
                                </div>
                                <div className='div-flex div-justify-between div-align-center comment-footer'>
                                        <div className='div-flex div-align-center comment-action'>
                                            {forum_auth.canComment&&<p onClick={()=>replyComment(s)} className='font-nunito margin-0 font-bold'>Balas</p>}
                                        
                                            <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                            {s.canMark&&s.isMark===false&&
                                                <>
                                                    <p onClick={()=>onClickMark(s,index,i2)} className='font-nunito margin-0 font-bold'>Tandai Sebagai Solusi</p>
                                                    <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                                </>
                                            }
                                            {forum_auth.canFlag&&s.isFlag===false&&
                                                <p onClick={()=>onClickFlag(s,index,i2)} className='font-nunito margin-0 font-bold'>Laporkan</p>
                                            }
                                            {(handleDisabledComment(s)||forum_auth.isAdministrator)&&<>
                                                <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                                <p onClick={()=>deleteComment(s,i2)} className='font-nunito margin-0 font-bold'>Hapus</p>

                                            </>}
                                        </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        {s.child.map((s2,i3)=>(
                            <div key={i3}>
                                <div className='sub-comment margin-left60 div-flex'>
                                    <div className='comment-ava'>
                                        <img className='comment-ava-img' src={s2.author.profilePic!==''?s2.author.profilePic:DefaultAva}/>
                                        {s2.nMark>0&&<div className='icon-status-wrapper'><img src={IsMark} className='icon-status'/><p className='font-nunito margin-0'>{s2.nMark}</p></div>}
                                        {s2.nflag>0&&<div className='icon-status-wrapper'><img src={IsFlag} className='icon-status'/><p className='font-nunito margin-0'>{s2.nflag}</p></div>}
                                    </div>
                                    <div style={{width:'100%'}}>
                                        <div className='sub-comment-content'>
                                            <div className='div-flex div-justify-between sub-coment-head'>
                                                <p className='font-nunito margin-0'><span className='font-bold'>{s2.author.name}</span></p>
                                                <p className='font-nunito margin-0' style={{color:'#777777'}}>{s2.lastActivity}</p>
                                            </div>
                                            <div className='sub-comment-desc'>
                                            <SmartText text={s2.text}/>
                                            </div>
                                        </div>
                                        <div className='div-flex div-justify-between div-align-center comment-footer'>
                                                <div className='div-flex div-align-center comment-action'>
                                                    {s2.canMark&&s2.isMark===false&&
                                                        <>
                                                            <p onClick={()=>onClickMark(s2,index,i2,i3)} className='font-nunito margin-0 font-bold'>Tandai Sebagai Solusi</p>
                                                            <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                                        </>
                                                    }
                                                    {forum_auth.canFlag&&s2.isFlag===false&&
                                                        <p onClick={()=>onClickFlag(s2,index,i2,i3)} className='font-nunito margin-0 font-bold'>Laporkan</p>
                                                    }
                                                    {(data.author.userId===profile.id||forum_auth.isAdministrator)&&<>
                                                        <div style={{width:1.5,height:15,backgroundColor:'#dddddd'}}></div>
                                                        <p onClick={()=>deleteComment(s2,i2)} className='font-nunito margin-0 font-bold'>Hapus</p>

                                                    </>}
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                            </div>
                        ))}
                        
                    </div>
                ))}
            </div>
        </div>
    )
}
